import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { supabase } from "../supabaseClient";

const OrderDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchOrder = async () => {
      const { data } = await supabase
        .from("orders")
        .select(`
          *,
          order_items (
            quantity,
            size,
            price,
            products (name, images)
          )
        `)
        .eq("id", id)
        .single();

      setOrder(data);
      setLoading(false);
    };

    fetchOrder();
  }, [id]);

  if (loading) return <p className="text-center mt-20">Loading...</p>;
  if (!order) return <p className="text-center mt-20">Order not found</p>;

  return (
    <div className="bg-cream min-h-screen">
      <div className="max-w-5xl mx-auto px-6 py-12">

        <h1 className="font-serif text-4xl text-charcoal mb-10">
          Order Details
        </h1>

        {/* HEADER */}
        <div className="bg-white rounded-xl border p-6 shadow-sm mb-8 flex justify-between">
          <div>
            <h2 className="text-2xl font-serif">Order #{order.id}</h2>
            <p className="text-sm text-gray-500">
              {new Date(order.created_at).toLocaleDateString()}
            </p>
          </div>

          <span className="bg-amber-100 text-amber-700 px-4 py-2 rounded-full text-xs uppercase font-semibold">
            {order.status}
          </span>
        </div>

        {/* SHIPPING */}
        <div className="bg-white rounded-xl border p-6 shadow-sm mb-8">
          <h3 className="font-serif text-xl mb-3">Shipping Address</h3>
          <p className="text-gray-600">{order.address}</p>
        </div>

        {/* PAYMENT */}
        <div className="bg-white rounded-xl border p-6 shadow-sm mb-8">
          <h3 className="font-serif text-xl mb-3">Payment Method</h3>
          <p className="text-gray-600">{order.payment_method}</p>
        </div>

        {/* ITEMS */}
        <div className="bg-white rounded-xl border p-6 shadow-sm mb-8">
          <h3 className="font-serif text-xl mb-6">Items</h3>

          {order.order_items.map((item, i) => (
            <div key={i} className="flex gap-6 mb-6">
              <img
                src={item.products.images[0]}
                alt=""
                className="w-24 h-28 object-cover rounded"
              />
              <div className="flex-1">
                <p className="font-medium">{item.products.name}</p>
                <p className="text-sm text-gray-500">
                  Size: {item.size} • Qty: {item.quantity}
                </p>
              </div>
              <p className="font-semibold text-[#ba8245]">
                ₹{item.price}
              </p>
            </div>
          ))}
        </div>

        {/* TOTAL */}
        <div className="bg-white rounded-xl border p-6 shadow-sm mb-8 flex justify-between">
          <span className="font-serif text-xl">Total</span>
          <span className="font-serif text-xl text-[#ba8245]">
            ₹{order.total_amount}
          </span>
        </div>

        {/* TRACK BUTTON */}
        <div className="text-center">
          <button
            onClick={() => navigate(`/track-order?id=${order.id}`)}
            className="bg-black text-white px-8 py-3 rounded-lg hover:bg-gray-800 transition"
          >
            Track Shipment
          </button>
        </div>
      </div>
    </div>
  );
};

export default OrderDetails;